import { useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

export const useEvents = () => {
  const [events, setEvents] = useState([]);
  const [editingEvent, setEditingEvent] = useState(null);
  const [eventForm, setEventForm] = useState({
    title: '',
    description: '',
    event_date: '',
    event_time: '',
    timezone: 'America/Chicago',
    link: ''
  });

  const fetchEvents = async () => {
    try {
      const response = await axios.get(`${API}/calendar/events?per_page=500`);
      setEvents(response.data.events || response.data || []);
    } catch (error) {
      toast.error('Failed to load events');
    }
  };

  const resetEventForm = () => {
    setEventForm({ title: '', description: '', event_date: '', event_time: '', timezone: 'America/Chicago', link: '' });
    setEditingEvent(null);
  };

  const handleEditEvent = (event, scrollRef) => {
    setEditingEvent(event.id);
    setEventForm({
      title: event.title,
      description: event.description,
      event_date: event.event_date,
      event_time: event.event_time,
      timezone: event.timezone || 'America/Chicago',
      link: event.link || ''
    });
    scrollRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const saveEvent = async (onSuccess) => {
    try {
      if (editingEvent) {
        await axios.put(`${API}/calendar/events/${editingEvent}`, eventForm);
        toast.success('Event updated!');
      } else {
        await axios.post(`${API}/calendar/events`, eventForm);
        toast.success('Event created!');
      }
      resetEventForm();
      if (onSuccess) onSuccess();
    } catch (error) {
      toast.error('Failed to save event');
    }
  };

  const deleteEvent = async (id, onSuccess) => {
    try {
      await axios.delete(`${API}/calendar/events/${id}`);
      toast.success('Event deleted!');
      if (onSuccess) onSuccess();
    } catch (error) {
      toast.error('Failed to delete event');
    }
  };

  return {
    events,
    editingEvent,
    eventForm,
    setEventForm,
    fetchEvents,
    resetEventForm,
    handleEditEvent,
    saveEvent,
    deleteEvent
  };
};

export default useEvents;
